import { render } from "./ImageViewList.vue?vue&type=template&id=720e9fba&scoped=true&ts=true"
import script from "./ImageViewList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageViewList.vue?vue&type=script&setup=true&lang=ts"

import "./ImageViewList.vue?vue&type=style&index=0&id=720e9fba&lang=sass&scoped=true"

import exportComponent from "/Users/voquanghoa/code/medicinal-plant/MedicinalPlant.Frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720e9fba"],['__file',"src/components/plant/ImageViewList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "720e9fba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('720e9fba', __exports__)) {
    api.reload('720e9fba', __exports__)
  }
  
  module.hot.accept("./ImageViewList.vue?vue&type=template&id=720e9fba&scoped=true&ts=true", () => {
    api.rerender('720e9fba', render)
  })

}


export default __exports__